import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, Microscope, Building2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ModeSelection = () => {
  const navigate = useNavigate();

  const selectMode = async (mode) => {
    try {
      // Set mode in localStorage first
      localStorage.setItem('medplexity_mode', mode);
      
      // Navigate to dashboard
      navigate('/dashboard');
      
      // Send API call in background (non-blocking)
      axios.post(`${API}/mode/select`, { mode }, { withCredentials: true }).catch(err => {
        console.error('Error saving mode to backend:', err);
      });
    } catch (error) {
      console.error('Error selecting mode:', error);
      // Still navigate even if there's an error
      navigate('/dashboard');
    }
  };

  return (
    <div className="landing-container" data-testid="mode-selection-page">
      <div className="landing-content">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem' }}>
          <h1 className="landing-title" data-testid="page-title">MedPlexity</h1>
          <span className="beta-badge" data-testid="beta-badge">Beta</span>
        </div>
        <p className="landing-subtitle" data-testid="page-subtitle">
          Select Your Mode to Get Started
        </p>
        
        <div className="mode-selection">
          <div 
            className="mode-card" 
            onClick={() => selectMode('patient')}
            data-testid="patient-mode-card"
          >
            <div className="mode-icon">
              <Activity size={64} color="#0277bd" />
            </div>
            <h2 className="mode-title">Patient Mode</h2>
            <p className="mode-description">
              Diagnosis assistance, report interpretation, disease understanding, and doctor discovery.
            </p>
          </div>
          
          <div 
            className="mode-card" 
            onClick={() => selectMode('clinic')}
            data-testid="clinic-mode-card"
          >
            <div className="mode-icon">
              <Building2 size={64} color="#0277bd" />
            </div>
            <h2 className="mode-title">Clinic Mode</h2>
            <p className="mode-description">
              Professional tools for healthcare providers: patient management, diagnosis support, and clinical insights.
            </p>
          </div>
          
          <div 
            className="mode-card" 
            onClick={() => selectMode('researcher')}
            data-testid="researcher-mode-card"
          >
            <div className="mode-icon">
              <Microscope size={64} color="#0277bd" />
            </div>
            <h2 className="mode-title">Researcher Mode</h2>
            <p className="mode-description">
              Access structured disease knowledge, research papers, studies, and global treatment modalities.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModeSelection;
